import { Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box } from "@mui/system";
import { ReactElement, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import { Talent, Talent_Entity } from "../entities/talent";
import Talents from "../hooks/talents/talents";
import { selectedTalentID } from "../redux/filmsReducer";
import { useCreateTalentMutation } from "../redux/talent/talentEndpoints";
import { useTalent } from "../redux/talent/talentHooks";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function TalentsRoute(): ReactElement {
  const params = useParams();

  if (params.id)
    return (
      <Box sx={{ flex: 1, minWidth: 0, display: "flex" }}>
        <Outlet />
      </Box>
    );

  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        background: "none",
        flex: 1,
        minWidth: 0,
        p: 2,
        gap: 2,
        width: "100%",
        position: "relative",
      }}
    >
      <Paper
        sx={{
          flex: 1,
          minWidth: 0,
          border: "none",
          display: "flex",
        }}
      >
        <Talents />
      </Paper>
    </Box>
  );
}
